import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../supabaseClient';
import BuchhaltungSettings from './BuchhaltungSettings';
import BuchhaltungContacts from './BuchhaltungContacts';
import BuchhaltungTransactions from './BuchhaltungTransactions';
import BuchhaltungDashboard from './BuchhaltungDashboard';
// YENİ: Rapor bileşenini import ediyoruz
import BuchhaltungReports from './BuchhaltungReports';
// YENİ: Resmi belgeler bileşenini import ediyoruz
import BuchhaltungDocuments from './BuchhaltungDocuments';
import BuchhaltungInvoices from './BuchhaltungInvoices';

export default function Buchhaltung() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [readOnly, setReadOnly] = useState(true);

  useEffect(() => {
    const checkUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data: profile } = await supabase.from('profiles').select('role').eq('id', user.id).single();
        if (profile?.role === 'treasurer' || profile?.role === 'super_admin' || user.email === 'turgaycelen03@gmail.com') {
          setReadOnly(false);
        } else {
          setReadOnly(true);
        }
      } else {
        setReadOnly(true);
      }
    };
    checkUser();
  }, []);

  const tabs = [
    { id: 'dashboard', label: 'Übersicht' },
    { id: 'transactions', label: 'Transaktionen' },
    { id: 'invoices', label: 'Rechnungen' },
    { id: 'documents', label: 'Offizielle Unterlagen' },
    { id: 'reports', label: 'Berichte' },
    { id: 'contacts', label: 'Kontakte' },
    { id: 'settings', label: 'Einstellungen' },
  ];

  return (
    <div className="container mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-800">Buchhaltung</h1>
        <div className="text-sm text-gray-500">
          Verwaltung {readOnly ? '(Nur Lesen)' : 'für den Kassierer/in'}
        </div>
      </div>

      {/* Sekmeler (Tabs) */}
      <div className="flex space-x-1 bg-gray-200 p-1 rounded-lg mb-6 w-fit overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
              activeTab === tab.id
                ? 'bg-white text-blue-600 shadow'
                : 'text-gray-600 hover:text-gray-800 hover:bg-gray-300'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* İçerik Alanı */}
      <div className="mt-4">
        {activeTab === 'dashboard' && <BuchhaltungDashboard readOnly={readOnly} />}
        {activeTab === 'transactions' && <BuchhaltungTransactions readOnly={readOnly} />}
        {activeTab === 'invoices' && <BuchhaltungInvoices readOnly={readOnly} />}
        {activeTab === 'documents' && <BuchhaltungDocuments readOnly={readOnly} />}
        {activeTab === 'reports' && <BuchhaltungReports readOnly={readOnly} />}
        {activeTab === 'contacts' && <BuchhaltungContacts readOnly={readOnly} />}
        {activeTab === 'settings' && <BuchhaltungSettings readOnly={readOnly} />}
      </div>
    </div>
  );
}